import React, { useEffect, useRef, useCallback } from 'react'
import Icon from 'react-native-vector-icons/MaterialIcons'
import { useDispatch } from 'APP/Hooks/redux'
import styled, { useTheme } from 'styled-components/native'
import { ScrollView, View, type StyleProp, type ViewStyle } from 'react-native'
import Typography from 'APP/Converse/Typography'

// Actions
import StartupActions from 'APP/Redux/StartupRedux'

// Services
import I18n from 'APP/I18n'

const LightBackground = styled(View)`
  background-color: ${({ theme }) => theme.colors.background};
  opacity: 0.4;
  position: absolute;
  height: 100%;
  width: 100%;
`

const StyledView = styled(View)`
  display: flex;
  align-items: center;
  gap: 16px;
`

const CenteredTypography = styled(Typography)`
  text-align: center;
`

const scrollContainer = {
  minHeight: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as StyleProp<ViewStyle>

const LockScreen = () => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const triggerAuthentication = useCallback(() => {
    dispatch(StartupActions.triggerAppLock())
  }, [dispatch])

  const debounceAuthenticationRef = useRef<NodeJS.Timeout | null>(null)

  const debouncedAuthentication = useCallback(() => {
    if (debounceAuthenticationRef.current) {
      clearTimeout(debounceAuthenticationRef.current)
    }

    // Set a new timeout and store its ID in the ref
    debounceAuthenticationRef.current = setTimeout(() => {
      triggerAuthentication()
    }, 2000)
  }, [triggerAuthentication])

  useEffect(() => {
    debouncedAuthentication()

    return () => {
      if (debounceAuthenticationRef.current !== null) {
        clearTimeout(debounceAuthenticationRef.current)
      }
    }
  }, [debouncedAuthentication])

  return (
    <ScrollView contentContainerStyle={scrollContainer} testID="LOCK_SCREEN">
      <LightBackground />

      <StyledView>
        <Icon name="lock" size={theme.metrics.icon.medium} color={theme.colors.text} />
        <CenteredTypography variant="h2">{I18n.t('LockScreen.title')}</CenteredTypography>
        <CenteredTypography variant="bodyNormal">
          {I18n.t('LockScreen.subtitle')}
        </CenteredTypography>
      </StyledView>
    </ScrollView>
  )
}

export default LockScreen
